import { Loader } from "src/ui/widgets";

import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { useGetCheckoutDetails } from "src/networking/terminals";
import { atomDossier } from "src/storage";
import { Paths } from "src/navigation";


export const ReturnCheckout = () => {
  const navigate = useNavigate();

  const dossier = useRecoilValue(atomDossier);
  const { crossGate: getCheckoutDetails, pending: getCheckoutDetailsPending } =
    useGetCheckoutDetails();

  const location = useLocation();
  const sessionId = new URLSearchParams(location.search).get("session_id");

  useEffect(() => {
    if (!sessionId || getCheckoutDetailsPending || !dossier) {
      return;
    }

    getCheckoutDetails(
      {
        headers: {
          xDossierId: dossier?.dossierId,
        },
        uriParams: {
          checkoutSessionId: sessionId,
        },
      },
      {
        onSuccess(data) {
          navigate(Paths.CheckoutResult, {
            state: {
              checkoutSuccess: data.status,
              email: data.customer_email,
            },
          });
        },
        onFailure() {
          navigate(Paths.CheckoutResult);
        },
      }
    );
  }, [sessionId]);

  return <Loader classes="m-auto" />;
};
